import FadeInSection from '../../../components/feature/FadeInSection';

const B = ({ children }: { children: React.ReactNode }) => (
  <strong style={{ color: '#1a1a1a', fontWeight: '700' }}>{children}</strong>
);

const reasons: {
  id: number;
  number: string;
  icon: string;
  title: string;
  description: React.ReactNode;
  imageUrl: string;
  reversed: boolean;
}[] = [
  {
    id: 1,
    number: '01',
    icon: 'ri-heart-2-line',
    title: 'お見合い料無料｜ご縁を大切にできる仕組み',
    description: (
      <>
        多くの結婚相談所では、お見合いごとに費用が発生します。{'\n'}
        そのため、「できるだけ慎重に…」と機会を減らしてしまう方も少なくありません。{'\n\n'}
        和ははでは、お見合い料はいただいておりません。{'\n\n'}
        費用を気にすることなく、{'\n'}
        <B>「会ってみる」というご縁のチャンスを大切にしていただきたい</B>{'\n'}
        そんな想いから、この仕組みにしています。
      </>
    ),
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason-detail-1.png',
    reversed: false,
  },
  {
    id: 2,
    number: '02',
    icon: 'ri-user-smile-line',
    title: '選ばれるプロフィール作成｜出会いの質が変わる',
    description: (
      <>
        シニア婚活において、プロフィールはとても重要です。{'\n'}
        実は、この内容によってお見合いの成立率は大きく変わります。{'\n\n'}
        和ははでは、会員様ご自身に任せるのではなく、{'\n'}
        <B>シニア専門カウンセラーである坂本が一緒に作成</B>いたします。{'\n\n'}
        その方の魅力や人柄がきちんと伝わるように整えることで、{'\n'}
        <B>「会ってみたい」と思われるプロフィール</B>へと仕上げていきます。
      </>
    ),
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason_detail_02.jpg',
    reversed: true,
  },
  {
    id: 3,
    number: '03',
    icon: 'ri-award-line',
    title: '代表 坂本が最初から最後まで担当｜安心感の違い',
    description: (
      <>
        和ははでは、最初のご相談から活動中のサポートまで、{'\n'}
        <B>すべて代表の坂本が一貫して担当いたします。</B>{'\n\n'}
        大手相談所のように担当が変わることがないため、{'\n'}
        状況やお気持ちを一から説明する必要がなく、{'\n'}
        安心してご相談いただけます。{'\n\n'}
        <B>「最初から同じ人が寄り添ってくれる」</B>{'\n'}
        この安心感は、活動を続けるうえで大きな支えになります。
      </>
    ),
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/greeting-message.jpeg',
    reversed: false,
  },
  {
    id: 4,
    number: '04',
    icon: 'ri-customer-service-2-line',
    title: 'いつでも相談できるサポート体制',
    description: (
      <>
        活動中は、迷いや不安が出てくるものです。{'\n\n'}
        和ははでは、面談やご相談を随時受け付けており、{'\n'}
        <B>「悩んだその時」にすぐにご相談いただける環境</B>を整えています。{'\n\n'}
        一人で抱え込むことなく、{'\n'}
        安心して進めていただけるようサポートいたします。
      </>
    ),
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason-detail-3.png',
    reversed: true,
  },
  {
    id: 5,
    number: '05',
    icon: 'ri-team-line',
    title: 'シニア特有のお悩みにも対応できる体制',
    description: (
      <>
        シニア世代の婚活では、{'\n'}
        相続や持ち家など、将来に関わる大切なテーマも出てきます。{'\n\n'}
        和ははでは、そうしたお悩みに対応できる{'\n'}
        <B>専門のサポートチームと連携</B>しています。{'\n\n'}
        デリケートな問題についても、{'\n'}
        安心してご相談いただける環境をご用意しています。
      </>
    ),
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason-detail-4.jpeg',
    reversed: false,
  },
  {
    id: 6,
    number: '06',
    icon: 'ri-smartphone-line',
    title: 'デジタルサポート｜スマホが苦手でも安心',
    description: (
      <>
        和ははでは、活動に必要なLINEやオンラインツールの使い方についても、{'\n'}
        無料でサポートしています。{'\n\n'}
        代表の坂本は、シニア向けのスマホ講師としての経験があり、{'\n'}
        <B>操作に不安がある方にも、わかりやすく丁寧にお伝えします。</B>{'\n\n'}
        「使い方がわからないから不安…」という理由で、{'\n'}
        チャンスを逃すことがないようお手伝いいたします。
      </>
    ),
    imageUrl:
      'https://media.genaiweb.ai/8a4f04ed-3960-472b-978d-5363f01a3123/reason-detail-5.jpeg',
    reversed: true,
  },
];

export default function ReasonDetailSection() {
  return (
    <section className="section-padding" style={{ background: '#fff' }}>
      <div className="content-width">
        {reasons.map((reason, index) => (
          <FadeInSection key={reason.id} className={`mb-20 ${index === reasons.length - 1 ? 'mb-0' : ''}`}>
            <div
              className={`flex flex-col ${reason.reversed ? 'lg:flex-row-reverse' : 'lg:flex-row'} gap-10 lg:gap-16 items-center`}
            >
              {/* Image */}
              <div className="w-full lg:w-1/2 shrink-0">
                <div className="w-full h-[300px] lg:h-[380px] rounded-2xl overflow-hidden">
                  <img
                    src={reason.imageUrl}
                    alt={`${reason.title} - 和はは シニア結婚相談所`}
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                    width={640}
                    height={380}
                  />
                </div>
              </div>

              {/* Content */}
              <div className="w-full lg:w-1/2">
                <div className="flex items-center gap-3 mb-4">
                  <span
                    style={{
                      fontSize: '48px',
                      fontWeight: '800',
                      color: '#f2ebe4',
                      lineHeight: '1',
                      fontFamily: 'Georgia, serif',
                    }}
                  >
                    {reason.number}
                  </span>
                  <div
                    className="flex items-center justify-center w-12 h-12 rounded-full"
                    style={{ background: '#f2f8f4' }}
                  >
                    <span className="flex items-center justify-center w-7 h-7">
                      <i className={`${reason.icon} text-[#5a9e6f] text-2xl`}></i>
                    </span>
                  </div>
                </div>

                <h2
                  style={{
                    color: '#4a3728',
                    fontSize: 'clamp(18px, 2.5vw, 26px)',
                    fontWeight: '700',
                    marginBottom: '16px',
                    lineHeight: '1.6',
                  }}
                >
                  {reason.title}
                </h2>

                <div
                  style={{
                    color: '#6b5a4e',
                    fontSize: '16px',
                    lineHeight: '1.9',
                    marginBottom: '20px',
                    whiteSpace: 'pre-line',
                  }}
                >
                  {reason.description}
                </div>
              </div>
            </div>

            {/* Divider */}
            {index < reasons.length - 1 && (
              <div
                className="mt-20 h-px"
                style={{ background: 'linear-gradient(to right, transparent, #e8d8cc, transparent)' }}
              />
            )}
          </FadeInSection>
        ))}
      </div>
    </section>
  );
}
